import EventBus from "./EventBus";

class Steam {
  constructor() {
    this.friendList = null;
    this.personaState = null;
    this.resultList = null;
    this.sliceResultList = null;
    this.invitedList = [];
    this.isSend = false
    this.isInit = false

    this.MAX_NETHOOK_NUM = 3;
    this.prioritySort = {
      ONLINE_HASINFO: 0,
      ONLINE_NOINFO: 1,
      LEAVE_HASINFO: 2,
      LEAVE_NOINFO: 3,
      OFFLINE_HASINFO: 4,
      OFFLINE_NOINFO: 5,
    };
  }

  init(isSteamNetHook) {
    if (!isSteamNetHook) return;

    this.isRun = true;
    this.getSteamFriendByInjectCb = (e, data) => {
      if (this.friendList) return;

      this.friendList = data.reduce((acc, cur) => {
        const steam_id = cur.ulfriendid;
        const relationship = cur.efriendrelationship
        if (this.isSteamId(steam_id) && this.isSteamFriend(relationship)) {
          acc.push({ steam_id: steam_id, appid: "0" });
        }
        return acc;
      }, []);

      if (this.personaState) this.formatFriendList();
    };
  
    this.timer = null
    this.getPersonaStateByInjectCb = (e, data) => {
      // INFO：如果我没发送包, 接收的包都是无用的包
      if(!this.isSend) return;
      /*
        INFO: 
        01 如果gameid太长为自定义游戏，自定义游戏存在loading状态导致一直刷新状态(1s至少2次)，
        认为该包也是无用的包，避免频繁更新状态
      */ 
      if(
        data && data.length === 1 && 
        data[0].gameid.length <= 20 && data[0].gameid.length >= 18
      ) return;
      
      const stateModifyDatas = []
      if (this.personaState) {
        data.forEach((item) => {
          const index = this.personaState.findIndex(
            (p) => p.friendid === item.friendid
          );
          if (index === -1) {
            this.personaState.push(item);
          } else {
            this.personaState[index] = item;
          }
          stateModifyDatas.push(item)
        });
      } else {
        this.personaState = data;
      }

      if (this.friendList) {
        if(!this.isInit) {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => this.formatFriendList(), 500);
        } else {
          this.formatFriendList(stateModifyDatas)
        }
      }
    };
    this.getFriendMessageByInjectCb = (e, data, otherSteamid) => {
      if (data)
        EventBus.$emit("Steam:Get_Steam_Friends_Message", data, otherSteamid);
    };

    this.getSteamFriendByInject(this.getSteamFriendByInjectCb);
    this.getPersonaStateByInject(this.getPersonaStateByInjectCb);
    this.getFriendMessageByInject(this.getFriendMessageByInjectCb);

    if (process.env.IS_CLIENT) {
      window.steamAPI.onGetSteamFriendsByInject(() => {
        window.steamAPI.sendSteamFriendByInject(this.sliceResultList);
      });
    }
  }

  formatFriendList(stateModifyDatas) {
    let stateList = null
    let updateAll = false
    if(stateModifyDatas && stateModifyDatas.length > 0) {
      stateList = stateModifyDatas
      updateAll = false
    } else {
      stateList = this.personaState
      updateAll = true
    }

    stateList?.forEach((item) => {
      const friend = this.friendList.find((f) => f.steam_id === item.friendid);
      if (friend) {
        friend.appid = item.gameid + "";
        friend.persona_state = item.persona_state;
      }
    });

    if(updateAll) {
      EventBus.$emit("Steam:Change_Steam_Friends", this.friendList);
    } else {
      EventBus.$emit("Steam:Change_Part_Steam_Friends", stateList);
    }
  }
  formatResultList(resultList = this.resultList, heyboxList = []) {
    if (!(resultList && Array.isArray(resultList))) return [];
    
    // 去重现有好友
    if (heyboxList.length > 0) {
      resultList = resultList.filter((item) => {
        if (!item.heybox_info) {
          return true;
        } else {
          return !heyboxList.find(
            (f) => f.user_id === item.heybox_info.user_id
          );
        }
      });
    }

    resultList?.forEach((item) => {
      const persona = this.personaState.find(
        (p) => item.steam_id === p.friendid
      );
      item.persona_state = persona ? persona.persona_state : 0;
      item.nickname = item.steam_nickname; // 使用steamname来做搜索
      item.remarks = "";
      item.isInvite = this.invitedList.includes(item.steam_id);
      item.appid = persona ? persona.gameid : '0'
    });

    this.resultList = this.sortPriorityByArray(resultList);
    this.sliceResultList = this.resultList.slice(0, 20);
    return this.sliceResultList
  }

  // list 为数组 [user_id, ...]
  filterHeyboxFriends(list) {
    if (!this.resultList) {
      return [];
    } else {
      return this.resultList.filter((f) => {
        if (!f.heybox_info) {
          return true;
        } else {
          return !list.includes(f.heybox_info.user_id);
        }
      });
    }
  }

  destory() {
    this.offPersonaStateByInject(this.getPersonaStateByInjectCb);
    this.offFriendMessageByInject(this.getFriendMessageByInjectCb);
    this.offSteamFriendByInject(this.getSteamFriendByInjectCb);
    this.friendList = null;
    this.personaState = null;
    this.resultList = null;
    this.invitedList = [];
  }

  isRunEnv(name) {
    if (window.client_env === "electron" && window.steamAPI) {
      return name ? !!window.steamAPI[name] : true;
    } else {
      return false;
    }
  }

  isOnline(data) {
    return data.persona_state === 1;
  }
  isLeave(data) {
    return [2, 3, 4, 7].includes(data.persona_state);
  }
  isOffline(data) {
    return data.persona_state === 0;
  }
  isHeyboxInfo(data) {
    return !!data.heybox_info;
  }
  sortPriorityByArray(list) {
    // 01 在线 persona_state = 1 / 有黑盒信息 有heybox_info
    // 02 在线 persona_state = 1 / 无黑盒信息 无heybox_info
    // 03 离开 persona_state = 2、3、4、7 / 有黑盒信息 有heybox_info
    // 04 离开 persona_state = 2、3、4、7 / 无黑盒信息 无heybox_info
    // 05 不在线 persona_state = 0 / 有黑盒信息 有heybox_info
    // 06 不在线 persona_state = 0 / 无黑盒信息 无heybox_info
    const result = list.reduce(
      (acc, cur) => {
        if (this.isOnline(cur) && this.isHeyboxInfo(cur)) {
          acc[this.prioritySort.ONLINE_HASINFO].push(cur);
        } else if (this.isOnline(cur) && !this.isHeyboxInfo(cur)) {
          acc[this.prioritySort.ONLINE_NOINFO].push(cur);
        } else if (this.isLeave(cur) && this.isHeyboxInfo(cur)) {
          acc[this.prioritySort.LEAVE_HASINFO].push(cur);
        } else if (this.isLeave(cur) && !this.isHeyboxInfo(cur)) {
          acc[this.prioritySort.LEAVE_NOINFO].push(cur);
        } else if (this.isOffline(cur) && this.isHeyboxInfo(cur)) {
          acc[this.prioritySort.OFFLINE_HASINFO].push(cur);
        } else if (this.isOffline(cur) && !this.isHeyboxInfo(cur)) {
          acc[this.prioritySort.OFFLINE_NOINFO].push(cur);
        } else {
          acc[this.prioritySort.OFFLINE_NOINFO].push(cur);
        }
        return acc;
      },
      [[], [], [], [], [], []]
    );

    const flatList = result.flat();
    return flatList;
  }

  sortPriority(list) {
    return list.sort((a, b) => {
      // 判断是否在线
      const aIsOnline = a.persona_state === 1;
      const bIsOnline = b.persona_state === 1;

      // 判断是否离开
      const aIsAway = [2, 3].includes(a.persona_state);
      const bIsAway = [2, 3].includes(b.persona_state);

      // 判断是否有 heybox_info
      const aHasHeyboxInfo = !!a.heybox_info;
      const bHasHeyboxInfo = !!b.heybox_info;

      const getPriority = (isOnline, isAway, hasHeyboxInfo) => {
        if (isOnline) {
          return hasHeyboxInfo ? 1 : 2;
        } else if (isAway) {
          return hasHeyboxInfo ? 3 : 4;
        } else {
          return hasHeyboxInfo ? 5 : 6;
        }
      };

      const priorityA = getPriority(aIsOnline, aIsAway, aHasHeyboxInfo);
      const priorityB = getPriority(bIsOnline, bIsAway, bHasHeyboxInfo);

      return priorityA - priorityB;
    });
  }

  // 过滤 steamid
  isSteamId(steamid) {
    return steamid.length === 17 && steamid.startsWith("7656");
  }

  isSteamFriend(relationship) {
    return relationship === 3
  }

  sendSteamFriendByInject(steamid) {
    if (!this.isRunEnv("sendFriendsList")) return;
    window.steamAPI?.sendFriendsList(steamid);
  }
  sendSteamPersonaStateByInject(steamid) {
    if (!this.isRunEnv("sendFriendsList")) return;
    window.steamAPI.sendPersonaState(steamid);
  }
  sendSteamFriendsMessageByInject(selfSteamid, otherSteamid, message) {
    if (!this.isRunEnv("sendFriendsMessage")) return;
    window.steamAPI.sendFriendsMessage(selfSteamid, otherSteamid, message);
  }

  getSteamFriendByInject(cb) {
    if (!this.isRunEnv("onGetFriendsList")) return;
    window.steamAPI.onGetFriendsList(cb);
  }
  getPersonaStateByInject(cb) {
    if (!this.isRunEnv("onPersonaState")) return;
    window.steamAPI.onPersonaState(cb);
  }
  getFriendMessageByInject(cb) {
    if (!this.isRunEnv("onFriendsMessage")) return;
    window.steamAPI.onFriendsMessage(cb);
  }

  offPersonaStateByInject(cb) {
    if (!this.isRunEnv("offPersonaState")) return;
    window.steamAPI.offPersonaState(cb);
  }
  offSteamFriendByInject(cb) {
    if (!this.isRunEnv("offSteamFriend")) return;
    window.steamAPI.offSteamFriend(cb);
  }
  offFriendMessageByInject(cb) {
    if (!this.isRunEnv("offFriendMessage")) return;
    window.steamAPI.offFriendMessage(cb);
  }
}

export default new Steam();
